<template>
  <div class="home home--landing">

    <!-- ROUTER CONTENT SHOULD GO HERE -->
    <modal-popup
      v-if="openPopup"
      @close="openPopup = false"
    >
      <!-- <h2 class="content-block__header">Hello!</h2>
      <p>Every year, students just like you decide to work on campus in various positions.</p>
      <p>Working on campus can do more than just help you pay for school and rent. It can also be a great way to gain relevant experience and develop key skills that employers value, especially if you have limited work experience.</p>
      <p>This toolkit will guide you throughout your on-campus work experience, and help you create an insightful and positive learning experience that will benefit your future career.</p>
      <p>In this toolkit, you’ll find…</p>
      <ul>
        <li><strong>Tips</strong> to help you find and secure a job on campus</li>
        <li><strong>Insight</strong> into the skills valued by employers</li>
        <li><strong>Guidance</strong> to set up meaningful goals for your on-campus experience </li>
        <li><strong>Reflective questions</strong> to support you during your work experience</li>
        <li><strong>Activities</strong> to help you recognize the skills you’ve gained from your work experience</li>
      </ul> -->

      <video
        src="@/assets/video/centennial college - toolkit testimonials - video 1.mp4"
        controls
        controlslist="nodownload"
        playsinline
        poster="@/assets/img/_poster/centennial - testimonial video - poster 1.jpg"
        class="content-block__img mb-0 img-fluid"
      >
        <!-- Language, format and path to closed caption file-->
        <track
          label="English"
          kind="subtitles"
          srclang="en"
          :src="`${publicPath}cc/CC-V1-Testimonial.vtt`"
          default
        />
      </video>
      <div class="accordion">
        <accordion
          headerText="Transcript"
          accordionID="collapse01"
        >
          <p><strong>Maria Pugliese</strong></p>
          <p>Project Assistant, Career Services Department</p>
          <p><strong>Quote: “This toolkit will guide you through your on-campus work experience”</strong></p>
          <p>Hello and welcome to the On-Campus Employment Toolkit. This magnificent tool has been created for you. My name is Maria and I work with the Career Services Department. Me, along with the rest of the team, have worked really hard for this project to become a reality, and we cannot wait for you to take advantage of it.</p>
          <p>In this toolkit, you will find a compilation of resources, tools, activities and testimonials that will guide you through your on-campus work experience and help you create an insightful and positive learning experience that will benefit your academic life and your future career. In this case, this project feels very close to home to me, as I was once a student employee myself.</p>
          <p>While completing my program at Centennial College, I had the opportunity to work part-time with the Career Services Department. At the time, I helped them develop and launch their Career Resilience initiative, which now reaches thousands of Centennial students and grads and provides tools for them to stay optimistic while job searching. I can certainly say that during this time I greatly enhanced my communication and interpersonal skills and improved my knowledge on project development. This experience not only allowed me to become familiar with the Canadian workplace culture as I was a newcomer, but also to expand my professional network. Also, it helped me make the important decision of going back to school and become a career development practitioner, which is the reason why I'm back on the team today. So it feels like a full circle moment to me to be sitting in front of you, introducing this toolkit that we worked so hard on and that I'm confident will help other student employees to be successful on their on-campus jobs and to make meaningful career decisions.</p>
          <p>We hope you enjoy it.</p>
        </accordion>
      </div>
    </modal-popup>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6 p-0 bg-img bg-img--landing">
          <!-- <img
            src="@/assets/img/_bg/landing-page-bkrnd.jpg"
            class="img-fluid d-none d-md-block"
            alt=""
            srcset=""
          > -->
        </div>
        <div class="col-md-6 p-5">
          <h1>
            <img
              src="@/assets/img/_title/0-Main-title.svg"
              alt="ON-CAMPUS EMPLOYMENT TOOLKIT FOR STUDENTS"
              class="img-fluid mt-3"
            >
          </h1>
          <button
            class="about-toolkit-btn"
            @click="openPopup = true"
          >about this toolkit</button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 routing-nav p-0">
          <router-link
            to="job-search"
            class="routing-nav__btn routing-nav__btn--border-right routing-nav__btn--border-bottom routing-nav__btn--green"
          >
            <div class="routing-nav__title">Job search</div>
            <p>Learn some tips and tricks for finding a great on-campus job to apply to</p>
            <div class="routing-nav__cta">Let’s go</div>
          </router-link>
        </div>

        <div class="col-md-3 routing-nav p-0">
          <router-link
            to="interview-prep"
            class="routing-nav__btn routing-nav__btn--border-right routing-nav__btn--border-bottom routing-nav__btn--blue"
          >
            <div class="routing-nav__title">Interview prep</div>
            <p>Get some advice on how to succeed in the interview</p>
            <div class="routing-nav__cta">Let’s go</div>
          </router-link>
        </div>

        <div class="col-md-3 routing-nav p-0">
          <router-link
            to="on-the-job-success"
            class="routing-nav__btn routing-nav__btn--border-right routing-nav__btn--border-bottom routing-nav__btn--purple"
          >
            <div class="routing-nav__title">On-the-job success</div>
            <p>See how you can make the most of your on-campus work experience</p>
            <div class="routing-nav__cta">Let’s go</div>
          </router-link>
        </div>

        <div class="col-md-3 routing-nav p-0">
          <router-link
            to="future-career-planning"
            class="routing-nav__btn routing-nav__btn--border-right routing-nav__btn--orange"
          >
            <div class="routing-nav__title">Future career planning </div>
            <p>Use what you’ve learned to advance your career </p>
            <div class="routing-nav__cta">Let’s go</div>
          </router-link>
        </div>
      </div>
    </div>

    <!-- <div
      class="landing"
      style="margin-top: 10rem;"
    >
      <p><em>This project is made possible with funding by the Government of Ontario and through eCampusOntario’s support of the Virtual Learning Strategy</em></p>
      <img
        src="@/assets/img/_branding/ontario-rev.svg"
        alt="Ontario logo"
        class="img-fluid img-thumb d-inline-block mx-5"
        width="200px"
        srcset=""
      >
      <img
        src="@/assets/img/_branding/ecampus-wht.svg"
        alt="ecampus logo"
        class="img-fluid img-thumb d-inline-block mx-5"
        width="180px"
        srcset=""
      >
    </div> -->
  </div>
</template>

<script>
import Accordion from '../components/Accordion.vue'
import ModalPopup from '../components/ModalPopup.vue'

export default {
  name: 'Landing',
  components: {
    Accordion,
    ModalPopup
  },

  data () {
    return {
      publicPath: process.env.BASE_URL,
      currentFontSize: 100,
      route01: '',
      route02: '',
      route03: '',

      openPopup: false
    }
  },

  methods: {
    resizeText () {
      const body = document.getElementsByTagName('html')[0]
      this.currentFontSize += 20
      if (this.currentFontSize >= 160) {
        this.currentFontSize = 100
      }

      body.style.fontSize = `${this.currentFontSize}%`
    },

    // Handle scrolling
    scrollTo (id) {
      setTimeout(() => {
        this.$scrollTo(id, { offset: -70 })
      }, 100)
      // VueScrollTo.scrollTo('#route01')
    }
  },

  mounted () {
  }
}
</script>
